// 
// window.onload = function() {
//   const buyNowBtn = document.querySelector('#AddToCartForm-template--22335721308461__main-9729124729133 div .shopify-payment-button');
//   const preOrderBtn = document.querySelector('#AddToCartForm-template--22335721308461__main-9729124729133 div .add-to-cart');
//   buyNowBtn.style.display = 'none';
//   preOrderBtn.innerHTML = 'PREORDER';
//   preOrderBtn.style.color = 'white';
  
// }

    const url = window.location.href;

    const badge = document.createElement('div');
    badge.innerHTML = 'Limited Edition';
    badge.style.backgroundColor = '#0570DA';
    badge.style.color = '#ffffff';
    badge.style.padding = '2px 4px 2px 4px';
    badge.style.position = 'absolute';
    badge.style.top = '0';

if (url === 'https://auntieannesswag.com/') {
  const product = document.querySelector("[data-product-id='9878340239661']");
  product.style.position = 'relative';
  badge.style.marginLeft = '-22px';
  console.log(product);
  product.append(badge);
}

if (url === 'https://auntieannesswag.com/collections/frontpage') {
  const product = document.querySelector("[data-product-id='9878340239661']");
  product.style.position = 'relative';
  badge.style.marginLeft = '-22px';
  console.log(product);
  product.append(badge);
}

if (url === 'https://auntieannesswag.com/collections/all') {
  const product = document.querySelector("[data-product-id='9878340239661']");
  product.style.position = 'relative';
  badge.style.marginLeft = '-22px';
  console.log(product);
  product.append(badge);
}

if ((url === 'https://auntieannesswag.com/collections/all/products/twisted-holiday-mug') || (url === 'https://auntieannesswag.com/collections/frontpage/products/twisted-holiday-mug')) {
    const product = document.querySelector("#ProductPhotos-template--22335721308461__main > div");
    product.style.position = 'relative';
    console.log(product);
    product.append(badge);
}
